// Una entrada de formación académica: título (negrita), institución y fechas
// (cursiva, azul grisáceo), en una línea compacta.
export default function EducationItem({ title, institution, period }) {
  return (
    <p className="cv-edu">
      <span className="cv-edu-title">{title}</span>
      {institution ? (
        <>
          <span className="cv-exp-sep"> — </span>
          <span className="cv-edu-institution">{institution}</span>
        </>
      ) : null}
      {period ? <span className="cv-edu-period"> · {period}</span> : null}
    </p>
  );
}
